export const TradeMethod = {
  HUB: "hub",
  EXTENSION: "extension",
} as const;

export type TradeMethodType = (typeof TradeMethod)[keyof typeof TradeMethod];
